import React from 'react';
import {t} from '@lingui/core/macro';

import {Login} from 'features/auth';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';

const LoginPage: React.FC = () => {


    return (
        <BlankLayout pageTitle={t`Авторизация`}>
            <Login/>
        </BlankLayout>
    );
};

export default LoginPage;